// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YBzEotwdKm_k0iYvN5JX8","icon":"_1WWj4HhzjhWQg3JZWg0MOo"};